import { Coordinate } from "ol/coordinate";
import React, { createContext, useContext, useEffect, useState } from "react";

type ClickMarker = "clickMarker" | "notClickMarker";

// Define the context type
type AllWeatherContextType = {
  setAtmosphericRivers: (value: string) => void;
  atmosphericRivers: string;
  setCyclones: (value: string) => void;
  cyclones: string;
  setTonardo: (value: string) => void;
  tonardo: string;
  setDroughts: (value: string) => void;
  droughts: string;
  setJetStreams: (value: string) => void;
  jetStreams: string;
  setStormSurges: (value: string) => void;
  stormSurges: string;
  setDustStorms: (value: string) => void;
  dustStorms: string;
  clickmarker: ClickMarker;
  setMarker: (newTheme: ClickMarker) => void;
};

// Create the context
const AllWeatherContext = createContext<AllWeatherContextType | undefined>(
  undefined
);

// Define the provider component
export const AllWeatherProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [atmosphericRivers, setAtmosphericRivers] = useState<string>("");
  const [cyclones, setCyclones] = useState<string>("");
  const [tonardo, setTonardo] = useState<string>("");
  const [droughts, setDroughts] = useState<string>("");
  const [jetStreams, setJetStreams] = useState<string>("");
  const [stormSurges, setStormSurges] = useState<string>("");
  const [dustStorms, setDustStorms] = useState<string>("");
  const [clickmarker, setClickmarker] = useState<ClickMarker>("notClickMarker");

  // Function to set the theme explicitly
  const setMarker = (isClicked: ClickMarker) => {
    setClickmarker(isClicked);
  };

  return (
    <AllWeatherContext.Provider
      value={{
        setAtmosphericRivers,
        atmosphericRivers,
        setCyclones,
        cyclones,
        setTonardo,
        tonardo,
        setDroughts,
        droughts,
        setJetStreams,
        jetStreams,
        setStormSurges,
        stormSurges,
        setDustStorms,
        dustStorms,
        setMarker,
        clickmarker,
      }}
    >
      {children}
    </AllWeatherContext.Provider>
  );
};

// Custom hook for using HzContext
export const useAllWeatherContext = () => {
  const context = useContext(AllWeatherContext);
  if (!context) {
    throw new Error(
      "useAllAllWeatherContext must be used within an AllAllWeatherProvider"
    );
  }
  return context;
};
